export const BASE_URL       = 'https://cinemapediaapi.electronicvillage.org';
export const FACEBOOK_ID    = '313949859659435'
export const GOOGLE_ID      = '869373708241-108ij95m8q0poo7ont8h9sghaf6f1a48.apps.googleusercontent.com'
export const USER_HOST      = 'https://evusers.electronicvillage.org'
export const RECAPTCHA      = '6LeEz_0hAAAAALYs3I-jTE3dvdC6JNAWnnD1jUUK'
export const APP_ID         = '32'
